module.exports = __webpack_public_path__ + "siteminder-src-icon.png?dba3acb492989fef3c2b5aa2f83fcdb4";